// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__VgZM+","setTabs":"Settings_setTabs__DJf55","contTabs":"Settings_contTabs__4PqWY"};